import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import {storeToRefs} from "pinia";


export function getPhoneTypeDirForDevice(chosenModel, isAppsSourceDevice = false, chosenAppSource = 'system') {

    const phoneTypesStore = usePhoneTypesStore()

    const {
        phoneTypes,
    } = storeToRefs(phoneTypesStore);


    if (chosenAppSource === 'common' && isAppsSourceDevice) {
        return 'common'
    }

    const phoneTypeIndex = phoneTypes.value.findIndex((phoneType) => {
        return phoneType.key === chosenModel;
    })

    if (phoneTypeIndex > -1) {
        return phoneTypes.value[phoneTypeIndex].value.dir
    }

    return false

}
